var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerPrimaryGradientH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 955,
    viewBox: "0 0 1 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.43144e-06 876.498L0 955L1 955L0.999997 874.967L-3.43144e-06 876.498Z",
    fill: "url(#paint0_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 873.264L0.999998 825.483C0.542685 827.009 0.220121 828.542 -1.88761e-06 830.081L-1.21917e-06 845.373C0.308355 849.997 0.586264 854.636 -6.12353e-07 859.255L-6.69217e-09 873.111C0.0401589 873.118 0.0804644 873.125 0.120887 873.131C0.411597 873.18 0.708342 873.23 1 873.264Z",
    fill: "url(#paint1_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 823.451C0.369511 823.361 0.722451 823.331 1 823.433L1 815.9L-2.97981e-07 816.634L-6.54797e-08 821.953C0.0889696 822.138 0.0985957 822.346 -3.78539e-08 822.585L0 823.451Z",
    fill: "url(#paint2_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.12773e-08 814.358C0.327885 814.376 0.662975 814.451 1 814.616L0.999999 791.291C0.673847 791.282 0.337623 791.292 -1.0166e-06 791.359L-1.12773e-08 814.358Z",
    fill: "url(#paint3_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.42652e-08 788.729C0.220302 789.466 0.519346 790.093 1 790.428L0.999999 778.805C0.953833 778.952 0.908398 779.102 0.862513 779.253C0.634354 780.005 0.395113 780.792 -3.8855e-07 781.539L-7.42652e-08 788.729Z",
    fill: "url(#paint4_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 740.887L0.865697 740.431C0.912984 740.489 0.957694 740.547 1 740.604L0.999999 728.887C0.679458 729.211 0.341698 729.339 -5.05085e-07 729.332L-4.32436e-07 730.994C0.60499 731.676 0.96179 732.565 0.843961 734.123C0.607856 734.646 0.313492 734.98 -2.48717e-07 735.197L0 740.887Z",
    fill: "url(#paint5_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.7363e-08 726.324C0.347796 726.572 0.693602 726.786 1 726.95L1 724.511C0.668325 724.61 0.322309 724.651 -1.02197e-07 724.612L-2.7363e-08 726.324Z",
    fill: "url(#paint6_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 720.514L1 720.247L0.999999 693.493C0.753872 696.23 0.393875 698.948 -8.2466e-07 701.648L0 720.514Z",
    fill: "url(#paint7_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.32436e-08 671.484C0.309603 671.592 0.642488 671.693 1 671.787L0.999999 640.531C0.990158 640.556 0.980284 640.582 0.97038 640.607C0.654436 641.422 0.307655 642.315 -1.24695e-06 643.26L-8.63168e-07 652.04C0.0668761 652.173 0.13803 652.306 0.213625 652.438C0.149512 652.427 0.0775465 652.414 -8.47563e-07 652.397L-1.32436e-08 671.484Z",
    fill: "url(#paint8_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.91514e-08 619.089C0.251475 619.693 0.59534 620.211 1 620.671L0.999999 608.218C0.757951 608.233 0.496228 608.24 0.213625 608.236L0.691812 615.325L-2.39451e-07 615.193L-6.91514e-08 619.089Z",
    fill: "url(#paint9_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.01585e-07 585.264C0.34847 585.896 0.667296 586.708 1 587.588L1 584.743C0.652818 584.962 0.325562 585.069 -1.08798e-07 585.099L-1.01585e-07 585.264Z",
    fill: "url(#paint10_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.31344e-08 583.666C0.255971 583.933 0.585337 584.186 1 584.424L1 577.571C0.979517 577.605 0.958999 577.64 0.938462 577.674C0.612641 578.223 0.281676 578.78 -2.22448e-07 579.335L-3.31344e-08 583.666Z",
    fill: "url(#paint11_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.31129e-09 572.546C0.344087 572.489 0.678754 572.49 1 572.576L0.999999 553.179C0.655149 553.368 0.319568 553.554 -8.23434e-07 553.738L-6.36524e-07 558.014C0.455538 558.306 0.802014 558.759 0.952636 559.46C0.653118 559.562 0.332178 559.618 -5.65232e-07 559.645L-1.31129e-09 572.546Z",
    fill: "url(#paint12_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.52852e-09 498.036C0.324738 498.117 0.658731 498.189 1 498.254L0.999999 483.079C0.655561 483.226 0.328712 483.337 -6.50994e-07 483.361L-2.39495e-07 492.775C0.13482 492.876 0.278324 492.978 0.430983 493.08C0.280776 493.124 0.137349 493.152 -2.22272e-07 493.169L-9.52852e-09 498.036Z",
    fill: "url(#paint13_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.3372e-08 418.609C0.402293 418.886 0.718652 419.313 1 419.83L1 417.818C0.742399 417.976 0.41421 418.128 -6.81043e-08 418.272L-5.3372e-08 418.609Z",
    fill: "url(#paint14_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 411.253C0.32584 411.182 0.663019 411.096 1 410.999L0.999999 399.326C0.893194 400.07 0.587169 400.797 -4.26274e-07 401.501L-4.0468e-07 401.995C0.698808 403.015 0.507371 403.801 -2.92779e-07 404.555L-1.54476e-07 407.719C0.174423 408.282 0.403303 408.874 0.691812 409.467L-7.22556e-08 409.6L0 411.253Z",
    fill: "url(#paint15_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.36075e-07 394.894C0.472775 395.95 0.870308 396.992 1 398.007L0.999999 381.843C0.449383 383.399 -0.00457948 385.026 0.083213 386.661C0.0545357 386.652 0.0268038 386.643 -4.97217e-07 386.632L-1.36075e-07 394.894Z",
    fill: "url(#paint16_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 374.068L1 374.001L0.999997 298.711C0.650838 298.898 0.318456 299.028 -3.27927e-06 299.047L-2.25398e-06 322.503C0.710617 325.232 1.28118 328.046 -1.88501e-06 330.944L0 374.068Z",
    fill: "url(#paint17_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 287.482C0.305181 287.279 0.624627 287.123 0.952637 287.027C0.968511 287.035 0.984299 287.042 1 287.05L1 279.697C0.582355 279.975 0.258781 280.248 -3.04363e-07 280.519L0 287.482Z",
    fill: "url(#paint18_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.19961e-08 278.89C0.184553 279.23 0.492136 279.425 1 279.389L1 272.345C0.912582 271.871 0.905138 271.396 1 270.92L1 270.399C0.564885 270.567 0.240868 270.706 -3.74617e-07 270.823L-2.19961e-08 278.89Z",
    fill: "url(#paint19_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.92734e-08 253.674L0.387511 255.03C0.778752 253.924 0.713545 252.537 0.409247 250.065C0.61414 250.132 0.810676 250.207 1 250.288L1 249.494C0.903232 249.646 0.807543 249.827 0.713548 250.044C0.240817 249.015 0.107971 248.113 -3.40775e-07 247.234L-2.221e-07 249.949C0.131792 249.984 0.259651 250.023 0.387511 250.065C0.22949 250.474 0.104563 250.68 -1.86955e-07 250.753L-5.92734e-08 253.674Z",
    fill: "url(#paint20_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 153.847L1 153.834L0.999995 47.173C0.674418 46.66 0.338549 46.184 -4.72586e-06 45.732L0 153.847Z",
    fill: "url(#paint21_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.30527e-09 28.481C0.335842 28.523 0.670095 28.592 1 28.671L0.999999 8.09003C0.652117 7.72503 0.316544 7.23101 -9.59247e-07 6.72601L-8.30527e-09 28.481Z",
    fill: "url(#paint22_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999738 257.103L0.256836 256.981L0.999738 257.467L0.999738 257.103Z",
    fill: "url(#paint23_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00018 260.984C0.790433 261.072 0.586071 261.161 0.387695 261.251L0.46129 261.257C0.642108 261.271 0.82099 261.284 1.00018 261.309L1.00018 260.984Z",
    fill: "url(#paint24_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00011 436.882C0.871446 436.797 0.739811 436.705 0.60498 436.608C0.743191 436.766 0.874772 436.918 1.00011 437.065L1.00011 436.882Z",
    fill: "url(#paint25_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999959 476.109C0.797585 476.634 0.572612 477.147 0.322266 477.645C0.567081 477.589 0.792584 477.542 0.999959 477.502L0.999959 476.109Z",
    fill: "url(#paint26_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 481.091C0.959698 481.261 0.955714 481.421 0.999998 481.566L0.999998 481.091Z",
    fill: "url(#paint27_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999814 625.075C0.283632 627.689 0.205774 629.198 0.999815 630.839L0.999814 625.075Z",
    fill: "url(#paint28_linear_22_102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999958 751.533C0.861482 753.546 0.906401 755.632 0.9468 757.509C1.01185 760.531 1.06519 763.008 0.322266 763.757C0.570814 764.044 0.79608 764.332 0.999959 764.619L0.999958 751.533Z",
    fill: "url(#paint29_linear_22_102)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_102",
    x1: 0.0685548,
    y1: 958.443,
    x2: 1.53519,
    y2: 958.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_102",
    x1: 0.0685548,
    y1: 875.32,
    x2: 1.53501,
    y2: 875.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_102",
    x1: 0.0685547,
    y1: 823.776,
    x2: 1.52424,
    y2: 823.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_102",
    x1: 0.0685547,
    y1: 815.62,
    x2: 1.53412,
    y2: 815.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_102",
    x1: 0.0685547,
    y1: 790.928,
    x2: 1.5306,
    y2: 790.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_102",
    x1: 0.0685547,
    y1: 741.403,
    x2: 1.53089,
    y2: 741.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_102",
    x1: 0.0685547,
    y1: 727.055,
    x2: 1.43581,
    y2: 726.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_102",
    x1: 0.0685547,
    y1: 721.676,
    x2: 1.53442,
    y2: 721.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_102",
    x1: 0.0685547,
    y1: 673.132,
    x2: 1.53464,
    y2: 673.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_102",
    x1: 0.0685547,
    y1: 621.207,
    x2: 1.53121,
    y2: 621.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_102",
    x1: 0.0685547,
    y1: 587.71,
    x2: 1.46084,
    y2: 587.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_102",
    x1: 0.0685547,
    y1: 584.719,
    x2: 1.52189,
    y2: 584.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_102",
    x1: 0.0685547,
    y1: 573.41,
    x2: 1.5336,
    y2: 573.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22_102",
    x1: 0.0685547,
    y1: 498.907,
    x2: 1.53254,
    y2: 498.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22_102",
    x1: 0.0685547,
    y1: 419.917,
    x2: 1.39362,
    y2: 419.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22_102",
    x1: 0.0685547,
    y1: 411.766,
    x2: 1.53084,
    y2: 411.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22_102",
    x1: 0.0685547,
    y1: 398.702,
    x2: 1.53286,
    y2: 398.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22_102",
    x1: 0.0685548,
    y1: 377.31,
    x2: 1.53518,
    y2: 377.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22_102",
    x1: 0.0685547,
    y1: 287.817,
    x2: 1.52489,
    y2: 287.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22_102",
    x1: 0.0685547,
    y1: 279.78,
    x2: 1.52748,
    y2: 279.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22_102",
    x1: 0.0685547,
    y1: 255.365,
    x2: 1.52492,
    y2: 255.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22_102",
    x1: 0.0685549,
    y1: 158.498,
    x2: 1.53523,
    y2: 158.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_22_102",
    x1: 0.0685547,
    y1: 29.6151,
    x2: 1.53397,
    y2: 29.5712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_22_102",
    x1: 0.307765,
    y1: 257.488,
    x2: 0.849484,
    y2: 256.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_22_102",
    x1: 0.429684,
    y1: 261.323,
    x2: 0.783783,
    y2: 260.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_22_102",
    x1: 0.632069,
    y1: 437.085,
    x2: 1.06996,
    y2: 436.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_22_102",
    x1: 0.368725,
    y1: 477.711,
    x2: 1.28548,
    y2: 477.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_22_102",
    x1: 0.970437,
    y1: 481.586,
    x2: 1.0169,
    y2: 481.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_22_102",
    x1: 0.471956,
    y1: 631.087,
    x2: 1.2997,
    y2: 631.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_22_102",
    x1: 0.368725,
    y1: 765.182,
    x2: 1.36157,
    y2: 765.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8C582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A16929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 955,
    height: 1,
    fill: "white",
    transform: "translate(0 955) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerPrimaryGradientH);
export default __webpack_public_path__ + "static/media/divider-primary-gradient-h.1f0d601aefef647e92ce72d5b8c129df.svg";
export { ForwardRef as ReactComponent };